import { Component, Input } from '@angular/core';
import { User } from '../../../shared';

@Component({
  selector: 'app-team-member-card',
  templateUrl: './team-member-card.component.html',
})
export class TeamMemberCardComponent {
  @Input() member: User;

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/team/components/team-member-card/team-member-card.component.ts